import styled from 'styled-components';
import trioLogo from '@/assets/trio-logo-with-text.svg';

export const Container = styled.div<{ isSmaller?: boolean }>`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: ${(props) => (props.isSmaller ? '860px' : '1160px')};
`;

export const Header = styled.header`
  height: 88px;
  background: ${(props) => props.theme.colors['primary-60']};
  display: flex;
  align-items: center;
  ${Container} {
    display: flex;
    align-items: center;
  }
`;

export const HeaderLogo = styled.a`
  margin-right: 16px;
  width: 103px;
  height: 32px;
  background-size: cover;
  font-size: 0;
  display: block;
  background-image: url(${trioLogo});
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-right: 32px;
    width: 113px;
    height: 35px;
  }
`;

export const InterviewStage = styled.p`
  font-weight: 600;
  display: inline;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-0']};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
    line-height: 21px;
  }
`;

export const CandidateInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const CandidateName = styled.p`
  font-weight: 400;
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 16px;
    margin-left: 16px;
    border-left: 1px solid;
  }
`;
